import { render, staticRenderFns } from "./additional-photo.vue?vue&type=template&id=89c92d64&"
import script from "./additional-photo.vue?vue&type=script&lang=js&"
export * from "./additional-photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports